import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isClientAuthenticated } = useAuth();

    if (!isClientAuthenticated) {
        return <Navigate to="/client/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
